module.exports = __webpack_public_path__ + "static/media/nw.login-bg-image.66d39680.png";